<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import Dropdown from 'primevue/dropdown'
import { getSupplierList } from '@/api/suppliers'
import type { Supplier } from '@/types/supplier-types'
import { useField } from 'vee-validate'
import { RouterLink } from 'vue-router'

const props = withDefaults(
  defineProps<{
    modelValue?: any
    label?: string
    placeholder?: string
    inputName: string
    disabled?: boolean
  }>(),
  {
    label: 'Finishing Supplier:',
    placeholder: 'Select who finished it'
  }
)

const emit = defineEmits(['update:modelValue'])
const { value, errorMessage } = useField<any>(props.inputName)

const computedValue = computed({
  get: () => props.modelValue || '',
  set: (newVal:  string) => {
    value.value = newVal
    emit('update:modelValue', newVal)
  }
})
const suppliers = ref<Supplier[]>([])

const selectedSupplierName = computed(() => {
  return suppliers.value.find(s => s.id === computedValue.value)?.name || 'Unknown Supplier';
});

onMounted(async () => {
  suppliers.value = await getSupplierList()
})
</script>

<template>
    <div class="flex flex-col gap-2">
      <label for="supplier">{{ label }}</label>
      <p v-if="disabled" class="py-2 font-medium text-[15px] bg-gray-50 rounded-lg px-2">
        <RouterLink
            :to="`/suppliers/${computedValue}`"
            class="font-medium text-neutral-800 hover:underline"
        >
          {{ selectedSupplierName }}
        </RouterLink>
      </p>
      <Dropdown
        v-else
        id="finishingSupplierId"
        v-model="computedValue"
        :options="suppliers"
        option-label="name"
        option-value="id"
        :placeholder="placeholder"
        :invalid="!!errorMessage"
      />
    </div>
  </template>